import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class InvitationService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/invitations`);
  }

  copyFromCompany(payload: { source_company_id: string; invitation_ids: string[]; target_bureau_id: string }, urlParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/invitations/copy_from`, urlParams);
    return this.http.post<any>(url, payload);
  }

  private attachmentsUrl(invitationId: string, urlParams: any): string {
    return `${sprintf(this.baseUrl, urlParams)}/${invitationId}/attachments`;
  }

  listAttachments(invitationId: string, urlParams: any = {}): Observable<any> {
    return this.http.get<any>(this.attachmentsUrl(invitationId, urlParams));
  }

  // Direct-to-S3 upload. Same pattern as EmailTemplateService.uploadAttachment:
  // presign → browser PUTs straight to S3 (bypasses the API path, so large
  // attachments don't hit ALB / CloudFront body/timeout limits) → finalize.
  // Returns the newly created InvitationAttachment row.
  uploadAttachment(invitationId: string, file: File, urlParams: any = {}): Observable<any> {
    const contentType = file.type || 'application/octet-stream';
    const presignUrl = `${this.attachmentsUrl(invitationId, urlParams)}/s3_put_url`;
    return this.http.post<any>(presignUrl, {
      file: { name: file.name, type: contentType },
    }).pipe(
      switchMap((s3File: any) => {
        // AuthInterceptor skips amazonaws.com URLs so no Authorization header
        // pollutes the request and invalidates the SigV4 signature.
        const headers = new HttpHeaders({ 'Content-Type': contentType });
        return this.http.put(s3File.url, file, { headers, responseType: 'text' }).pipe(
          switchMap(() => this.http.put<any>(presignUrl, {
            file: { key: s3File.key, name: file.name, type: contentType },
          })),
        );
      }),
    );
  }

  deleteAttachment(invitationId: string, attachmentId: number, urlParams: any = {}): Observable<any> {
    return this.http.delete<any>(`${this.attachmentsUrl(invitationId, urlParams)}/${attachmentId}`);
  }
}
